import {useEffect} from 'react';

import {powerbi} from 'powerbi-client';

export function useReportCleanup(selectedReport, containerId) {
  useEffect(() => {
    return () => {
      try {
        // Clean up by container reference (preferred)
        const container = containerId ? document.getElementById(containerId) : null;

        if (container) {
          const existingReport = powerbi?.get(container);
          if (existingReport) {
            existingReport.destroy();
            powerbi.reset(container);
            console.info('✅ Power BI container cleaned up');
          }
        }
      } catch (err) {
        console.error('⚠️ Error cleaning up Power BI embed:', err);
      }

      // Also destroy any selectedReport reference
      if (selectedReport) {
        try {
          selectedReport.destroy?.();
          console.info('✅ Selected report instance destroyed');
        } catch (err) {
          console.error('⚠️ Error destroying selectedReport instance:', err);
        }
      }
    };
  }, [selectedReport, containerId]);
}
